/**
 * @description:字段配置
 * @author:rzl
 * @date:2021/5/25 11:03
 **/
import Table from "../../../../assets/tables/parts/table";
import Column from "../../../../assets/tables/parts/column";
import ColumnType from "../../../../assets/tables/parts/column_type"

export default class dic_item extends Table{
    constructor() {
        super();
        this.name = "dic_item";
        this.CNName = "字典信息";
        this.columnArray = [
            new Column("系统编号","id",ColumnType.String,false).setVisible(false),
            new Column("字典名称","dictName",ColumnType.String,true).setTableView(),
            new Column("字典编码","dictCode",ColumnType.String,true).setTableView(),

        ];
        this.actions = [new Column("操作","actions","actions",false)
            .setDefaultValue(["view","delete","edit"]).setTableView(250)];
    }
}